import {Checkbox, FormControlLabel} from "@mui/material";
import React from "react";

export function Form_Checkbox(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;
    return (<>
        {/*<FormControl component="fieldset">*/}
        <FormControlLabel control={<Checkbox
            checked={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? false : localFormState[item.key]}
            onChange={
                (e) => {
                    // submit new state to the upper system
                    setLocalFormState({
                        ...localFormState,
                        [item.key]: e.target.checked
                    });
                }
            }
        />} label={item.label} />
        {/*</FormControl>*/}
    </>);
}